import { Controller } from "@hotwired/stimulus"
import { parseNumber, formatNumberArgentina } from "../utils/number_formatter"

export default class extends Controller {
  static targets = ["invoiceSelect", "amountInput", "errorMessage", "receiptInput"]

  connect() {
    this.updateMaxAmount()
  }

  // Use shared utility functions
  parseNumber = parseNumber
  formatNumberArgentina = formatNumberArgentina

  updateMaxAmount() {
    const invoiceSelect = this.invoiceSelectTarget
    const amountInput = this.amountInputTarget
    const errorMessage = this.errorMessageTarget

    if (!invoiceSelect || !amountInput) return

    const selectedOption = invoiceSelect.options[invoiceSelect.selectedIndex]

    if (selectedOption && selectedOption.value) {
      // Obtener el máximo permitido (mínimo entre factura y OC)
      const maxAllowed = parseFloat(selectedOption.getAttribute('data-max-allowed')) || 0
      const isPoLimit = selectedOption.getAttribute('data-is-po-limit') === 'true'
      const maxAllowedDisplay = selectedOption.getAttribute('data-max-allowed-display') || '0,00'
      const poRemainingDisplay = selectedOption.getAttribute('data-po-remaining-display') || '0,00'
      const invoiceRemainingDisplay = selectedOption.getAttribute('data-remaining-display') || '0,00'

      const maxAmount = maxAllowed / 100.0

      amountInput.setAttribute('data-max-allowed', maxAllowed.toString())
      amountInput.setAttribute('data-max-amount', maxAmount.toString())
      amountInput.setAttribute('data-is-po-limit', isPoLimit.toString())
      amountInput.setAttribute('data-max-allowed-display', maxAllowedDisplay)
      amountInput.setAttribute('data-po-remaining-display', poRemainingDisplay)
      amountInput.setAttribute('data-invoice-remaining-display', invoiceRemainingDisplay)

      // Limpiar mensaje de error
      if (errorMessage) {
        errorMessage.classList.add('d-none')
        errorMessage.textContent = ''
      }

      // Si el valor actual excede el máximo, ajustarlo
      const currentValue = this.parseNumber(amountInput.value)
      if (isNaN(currentValue)) {
        // Si el valor no es válido, resetear a 0
        amountInput.value = this.formatNumberArgentina(0, 2)
        return
      }
      const tolerance = 0.01
      if (currentValue > maxAmount + tolerance) {
        amountInput.value = this.formatNumberArgentina(maxAmount, 2)
      }
    } else {
      amountInput.removeAttribute('data-max-allowed')
      amountInput.removeAttribute('data-max-amount')
      amountInput.removeAttribute('data-is-po-limit')
      amountInput.removeAttribute('data-max-allowed-display')
      amountInput.removeAttribute('data-po-remaining-display')
      amountInput.removeAttribute('data-invoice-remaining-display')
    }
  }

  // Formatea el campo de monto cuando el usuario sale del campo (blur)
  formatAmountInput(event) {
    const input = event.target;
    if (input.value && input.value !== "") {
      const parsed = this.parseNumber(input.value);
      input.value = this.formatNumberArgentina(parsed, 2);
    }
  }

  validateAmount(event) {
    const amountInput = this.amountInputTarget
    const errorMessage = this.errorMessageTarget
    const invoiceSelect = this.invoiceSelectTarget

    if (!amountInput || !errorMessage || !invoiceSelect) return

    const selectedOption = invoiceSelect.options[invoiceSelect.selectedIndex]
    if (!selectedOption || !selectedOption.value) {
      errorMessage.classList.add('d-none')
      return
    }

    const value = this.parseNumber(amountInput.value)
    if (isNaN(value)) {
      errorMessage.textContent = 'El monto ingresado no es válido'
      errorMessage.classList.remove('d-none')
      return
    }
    const maxAllowed = parseFloat(selectedOption.getAttribute('data-max-allowed')) || 0
    const maxAmount = maxAllowed / 100.0
    const isPoLimit = selectedOption.getAttribute('data-is-po-limit') === 'true'
    const maxAllowedDisplay = selectedOption.getAttribute('data-max-allowed-display') || '0,00'

    if (value > maxAmount) {
      if (isPoLimit) {
        errorMessage.textContent = `El monto no puede exceder el pendiente de la orden de compra ($${maxAllowedDisplay})`
      } else {
        errorMessage.textContent = `El monto no puede exceder el pendiente de la factura ($${maxAllowedDisplay})`
      }
      errorMessage.classList.remove('d-none')
    } else {
      errorMessage.classList.add('d-none')
      amountInput.setCustomValidity('')
    }
  }

  validateBeforeSubmit(event) {
    const amountInput = this.amountInputTarget
    const invoiceSelect = this.invoiceSelectTarget
    // Sin target cuando el pago sale de un débito del banco: ahí el comprobante es opcional.
    const receiptInput = this.hasReceiptInputTarget ? this.receiptInputTarget : null

    if (!amountInput || !invoiceSelect) return

    // Validar factura seleccionada
    const selectedOption = invoiceSelect.options[invoiceSelect.selectedIndex]
    if (!selectedOption || !selectedOption.value) {
      event.preventDefault()
      alert('Por favor seleccione una factura')
      return false
    }

    // Validar monto
    const value = this.parseNumber(amountInput.value)
    if (isNaN(value)) {
      event.preventDefault()
      alert('El monto ingresado no es válido. Por favor ingrese un número válido.')
      amountInput.focus()
      return false
    }
    const maxAllowed = parseFloat(amountInput.getAttribute('data-max-allowed')) || 0
    const maxAmount = maxAllowed / 100.0
    const isPoLimit = amountInput.getAttribute('data-is-po-limit') === 'true'
    const maxAllowedDisplay = amountInput.getAttribute('data-max-allowed-display') || '0,00'

    if (value > maxAmount) {
      event.preventDefault()
      if (isPoLimit) {
        alert(`El monto no puede exceder el pendiente de la orden de compra ($${maxAllowedDisplay})`)
      } else {
        alert(`El monto no puede exceder el pendiente de la factura ($${maxAllowedDisplay})`)
      }
      this.validateAmount({ target: amountInput })
      return false
    }

    // Validar comprobante
    if (receiptInput && (!receiptInput.files || receiptInput.files.length === 0)) {
      event.preventDefault()
      alert('El comprobante es obligatorio. Por favor seleccione un archivo.')
      receiptInput.focus()
      return false
    }

    return true
  }
}
